import axios from "axios";
import { SERVER_API } from "../../Constant/AppConstants";

export const CreateTicket_api = async (payload: any) => {
  try {
    const response = await axios.post(
      `${SERVER_API}/Tickets/create_ticket.php`,
      payload,
    );
    return response.data;
  } catch (error) {
    console.error("Create ticket failed:", error);
    return { error: "Create ticket failed" };
  }
};

export const FetchTicketList_api = async (
  page: number,
  limit: number,
  keyword: string = "",
  status: string = "",
) => {
  try {
    const response = await axios.get(
      `${SERVER_API}/Tickets/fetch_tickets.php`,
      {
        params: { page, limit, keyword, status },
      },
    );
    return response.data;
  } catch (error) {
    console.error("Fetch ticket list failed:", error);
    return { error: "Fetch ticket list failed" };
  }
};

export const UpdateTicket_api = async (payload: any) => {
  try {
    const response = await axios.post(
      `${SERVER_API}/Tickets/update_ticket.php`,
      payload,
    );
    return response.data;
  } catch (error) {
    console.error("Update ticket failed:", error);
    return { error: "Update ticket failed" };
  }
};
